import instance from "@/services/interceptor.js";

export const getClienti = () => instance.get("/clienti");
export const salvaCliente = (cliente) => cliente.clienteID ? instance.put(`/clienti/${cliente.clienteID}`, cliente) : instance.post("/clienti", cliente);
export const eliminaCliente = (id) => instance.delete(`/clienti/${id}`);
export const esportaClienti = () => instance.get("/clienti/export", { responseType: 'blob' });
export const importaClienti = (formData) => instance.post("/clienti/import", formData, { headers: { "Content-Type": "multipart/form-data" } });